import { getEnglishCaseStudyBySlug } from "@/app/seo-case-studies-en";
import { CaseStudyLayout } from "./CaseStudyLayout";

export default function ResponderOperatorFirstHotlineCaseStudy() {
  const study = getEnglishCaseStudyBySlug("responder-operator-first-hotline");
  if (!study) return null;
  return <CaseStudyLayout study={study} />;
}
